export default __webpack_public_path__ + "static/media/ulucinar9.ef15ac82.jpg";